import react from '../../assets/icons/react.svg'
import python from '../../assets/icons/python.svg'

const languages = [
    {
        icon: python,
        name: 'Python',
        level: '100'
    },
    {
        icon: react,
        name: 'Java',
        level: '100'
    },
    {
        icon: react,
        name: 'HTML',
        level: '100'
    },
    {
        icon: react,
        name: 'REACTJS',
        level: '100'
    },
    {
        icon: react,
        name: 'Django',
        level: '100'
    },
    {
        icon: react,
        name: 'Bootstrap',
        level: '100'
    },

    
    {
        icon: react,
        name: 'React Native',
        level: '100'
    },

    {
        icon: react,
        name: 'Flutter',
        level: '100'
    },

    {
        icon: react,
        name: 'Golang',
        level: '100'
    },
    {
        icon: react,
        name: 'Laravel',
        level: '100'
    },
    {
        icon: react,
        name: 'C++',
        level: '100'
    },

]

const tools = [
    {
        icon: react,
        name: 'Figma',
        level: '100'
    },
    {
        icon: react,
        name: 'Photoshop',
        level: '100'
    },
    {
        icon: react,
        name: 'Illustrator',
        level: '100'
    },
    {
        icon: react,
        name: 'Framer',
        level: '100'
    },


]

export { tools, languages }